import { Icon as IconifyIcon, IconProps } from "@iconify/react";

export const Icon = ({ icon, ...props }: IconProps) => <IconifyIcon icon={`immi:${icon}`} width={24} {...props} />;